import React, { memo } from "react";
import { Spinner } from "reactstrap";
import styles from "./style.module.scss";

const LoadingScreen = ({ text = "" }) => (
  <div className={styles.loadingOverlay}>
    <div className={styles.loadingContent}>
      <Spinner className={styles.spinner} type="grow" />
      {text && <p className="text-muted">{text}</p>}
    </div>
  </div>
);

export default memo(LoadingScreen);
